import * as React from 'react'
import { forwardRef, FunctionComponent, ReactElement, Ref, useState } from 'react'
import { Dialog, DialogSurface, DialogTrigger, Tooltip, TooltipProps } from '@fluentui/react-components'

export type HammockDialogProps<DialogBodyPropsT = unknown> = {
    key?: string | number

    open?: boolean
    setOpen?: (open: boolean) => void
    onDismiss?: () => void

    triggerComponent?: (props: any, ref: Ref<any>) => ReactElement
    tooltipProps?: Partial<TooltipProps> & Pick<TooltipProps, 'content'>

    dialogBody: FunctionComponent<HammockDialogProps<DialogBodyPropsT>>
    dialogBodyProps?: () => DialogBodyPropsT
}

/**
 * The simplest Dialog we can make. It contains an optional DialogTrigger (+ Tooltip) and a simple DialogSurface. Typing can be anything you like.
 *
 * @param props all optional props, except dialogBody.
 */
export default function HammockDialog<DialogBodyPropsT = unknown>(props: HammockDialogProps<DialogBodyPropsT>): ReactElement {
    const [open, setOpen] = useState(false)

    const TriggerComponent = forwardRef<HTMLElement, any>((_props, ref) => {
        return props.triggerComponent ? (
            <Tooltip key={`${props.key}-1`} relationship={'description'} withArrow {...props.tooltipProps}>
                {props.triggerComponent?.(_props, ref)}
            </Tooltip>
        ) : undefined
    })

    //We set styles on this Dialog in Base.scss
    return (
        <Dialog open={props.open || open} onOpenChange={(event, data) => (props.setOpen ? props.setOpen(data.open) : setOpen(data.open))}>
            <DialogTrigger disableButtonEnhancement>
                <TriggerComponent />
            </DialogTrigger>
            <DialogSurface>
                {props.dialogBody ? <props.dialogBody onDismiss={() => (props.setOpen ? props.setOpen(false) : setOpen(false))} {...props} /> : <></>}
            </DialogSurface>
        </Dialog>
    )
}
